import React, { memo } from 'react';
import { Stack, Typography, Card } from 'investira.react.components';

const AvaliacoesHighlights = memo(() => {
  const NOTA = 3.5;

  return (
    <Stack sx={{ gap: 1, flex: 1, mb: 2 }} direction>
      {/* <Stack gap={1} flex={1}>
        <Card
          sx={{
            flex: 1,
            display: 'flex',
            minHeight: 0,
            backgroundColor:
              NOTA < 1.8
                ? 'error.main'
                : NOTA < 2.2
                ? 'warning.main'
                : NOTA < 3
                ? 'info.main'
                : 'primary.main' // TODO: a cor deve se ajusta de acordo com a nota
          }}>
          <Stack p={2} justifyContent="space-between">
            <Typography variant="caption" color="secondary.main" sx={{ fontWeight: 500 }}>
              Pontuação Média
            </Typography>
            <Stack direction="column" justifyContent="flex-end">
              <Stack direction="row" alignItems="baseline" gap={1}>
                <Typography variant="h5" color="secondary.main">
                  <b>{NOTA}</b>
                </Typography>
                <Typography variant="caption" color="secondary.main">
                  de 4
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Card>
      </Stack> */}
      <Stack gap={1} flex={1}>
        <Card
          sx={{
            flex: 1,
            display: 'flex',
            minHeight: 0
          }}>
          <Stack p={2} justifyContent="space-between">
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
              Total de Avaliações
            </Typography>
            <Stack direction="column" justifyContent="flex-end">
              <Stack>
                <Typography variant="h5" color="textPrimary">
                  <b>3</b>
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Card>
      </Stack>
      <Stack gap={1} flex={1}>
        <Card
          sx={{
            flex: 1,
            display: 'flex',
            minHeight: 0
          }}>
          <Stack p={2} justifyContent="space-between">
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
              Pendentes
            </Typography>
            <Stack direction="column" justifyContent="flex-end">
              <Stack>
                <Typography variant="h5" color="textPrimary">
                  <b>1</b>
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Card>
      </Stack>
      <Stack gap={1} flex={1}>
        <Card
          sx={{
            flex: 1,
            display: 'flex',
            minHeight: 0
          }}>
          <Stack p={2} justifyContent="space-between">
            <Typography variant="caption" color="textSecondary" sx={{ fontWeight: 500 }}>
              Concluídas
            </Typography>
            <Stack direction="column" justifyContent="flex-end">
              <Stack>
                <Typography variant="h5" color="textPrimary">
                  <b>1</b>
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Card>
      </Stack>
    </Stack>
  );
});

export default AvaliacoesHighlights;
